import React from 'react';
import { Alert, Button } from 'antd';
import Styles from './ErrorState.module.scss';

interface ErrorStateProps {
    /** Error message */
    message: string;
    /** Error description */
    description?: string;
    /** Show retry button */
    showRetry?: boolean;
    /** Retry handler */
    onRetry?: () => void;
    /** Custom className */
    className?: string;
}

/**
 * Reusable error state component
 */
export default function ErrorState({ message, description, showRetry = false, onRetry, className }: ErrorStateProps) {
    const containerClass = `${Styles.container} ${className || ''}`.trim();

    return (
        <div className={containerClass}>
            <Alert
                type="error"
                message={message}
                description={description}
                showIcon
                action={
                    showRetry && onRetry ? (
                        <Button
                            size="small"
                            onClick={onRetry}
                        >
                            Retry
                        </Button>
                    ) : undefined
                }
            />
        </div>
    );
}
